// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultAppliedGiftCard_requiredFieldsBody = {};

var defaultAppliedGiftCard = {
  giftCardType: "",
  maskedNumber: "",
  balance: 0.0,
  currency: "",
  id: "",
  requiredFieldsBody: defaultAppliedGiftCard_requiredFieldsBody
};

var defaultGiftCardInfo_appliedGiftCards = [];

var defaultGiftCardInfo = {
  appliedGiftCards: defaultGiftCardInfo_appliedGiftCards,
  remainingAmount: 0.0
};

export {
  defaultAppliedGiftCard ,
  defaultGiftCardInfo ,
}
/* No side effect */
